module.exports = __webpack_public_path__ + "img/nvidia_deeplearning.5805746b.jpg";